import {getChannelCategoryTree} from '@/services/channelManagement'
import { Button, Popconfirm, TreeSelect, message } from 'antd'
import {useEffect, useRef, useState} from 'react'
import { useNavigate } from 'react-router-dom'
import { SActionBtn, SIDRender, SLowcodeList, STableActions } from 'shj-components'
import config from './config'

import {getAuth, iiHOC} from '@/utils/auth'
import CheckThePhone from '@/components/CheckThePhone'
import {clueServiceEdit} from "@/pages/clueManage/details/clueServiceEdit.tsx";
import {getClueInvalidPage} from "@/services/saleOpServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import {salesBatchReceive, salesReceive, salesSeaBatchDispatch} from "@/services/callCenter";
import {httpOrgList} from "@/services/homeService.ts";
import {getRealEstateList} from "@/services/customerServices.ts";
import {getChannels} from "@/services/getUsers.ts";
import KeepAlive from "react-activation";
import {getUser} from "shj-utils";
import {openInNewTab} from "@/utils/queryParse.ts";
import {isHeadquarters} from "@/utils/common.ts";

const SalePublicInfo = (props) => {
  const navigate = useNavigate()
  const {companyId} = getUser()
  const listRef = useRef<any>()
  const configNew = { ...config }

  useEffect(() => {
    onCompanyChange(companyId)
  }, [companyId]);

  const fetchList = (values: any) => {
    return new Promise( (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        if (query.reasonCode) {
          query.reasonCode = query.reasonCode.pop()
        }
        if (query.createDate) {
          query.createdTimeStartWith = query.createDate[0].format('YYYY-MM-DD HH:mm:ss')
          query.createdTimeEndWith = query.createDate[1].format('YYYY-MM-DD HH:mm:ss')
          delete query.createDate
        }
        if (query.firstDate) {
          query.firstDateStart = query.firstDate[0].format('YYYY-MM-DD HH:mm:ss')
          query.firstDateEnd = query.firstDate[1].format('YYYY-MM-DD HH:mm:ss')
          delete query.firstDate
        }
        if (query.submitInvalidTime) {
          query.submitInvalidTimeStart = query.submitInvalidTime[0].format('YYYY-MM-DD HH:mm:ss')
          query.submitInvalidTimeEnd = query.submitInvalidTime[1].format('YYYY-MM-DD HH:mm:ss')
          delete query.submitInvalidTime
        }
        const queryData = {
          ...query,
        }
        getClueInvalidPage({params: {pageId: current, pageSize}, data: {...queryData}})
            .then(data => resolve(apiData2Table(data)))
            .finally(() => {
            })
      } catch {
        reject({ success: false })
      }
    })
  }
  const assignDesignAll = ({ selectedRowKeys }: { selectedRowKeys: number[] }) => {
    clueServiceEdit({ listRef, ids: selectedRowKeys, buttonKey: 'YXHighSeasPoolAssign', type: '营销员' })
  }
  const receive = (bizOpIds: number[]) => {
    salesReceive(bizOpIds).then(() => {
      message.success('领取成功')
      listRef.current.reload()
    })
  }
  const allReceiveFn = ({ selectedRowKeys }: { selectedRowKeys: number[] }) => {
    salesBatchReceive({clueIds: selectedRowKeys}).then(() => {
      message.success('领取成功')
      listRef.current.reload()
    })
  }

  const onCompanyChange = (value: any) => {
    if (value) {
      getRealEstateList({orgId: value}).then(res => {
        listRef?.current?.updateSearchData('buildingId', res)
      })
    } else {
      listRef?.current?.updateSearchData('buildingId', [])
    }
  }

  const getStatusOptions = () => {
    return Promise.all([
      httpOrgList(),
      getChannels(),
    ]).then(resp => {
      return {
        companyList: resp[0],
        channels: resp[1],
      }
    })
  }
  // const filterOption = (input: string, option: any) => option.children.indexOf(input) >= 0
  const filterTreeNode = (inputValue: any, treeNode: any) =>
    treeNode.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
  const extension = {
    onSearchReset: () => {
      listRef?.current?.updateSearchData('buildingId', [])
    },
    request: { fetchList, getStatusOptions },
    auth: getAuth(),
    events: { filterTreeNode, onCompanyChange, assignDesignAll },
    customRender: {
      clueIdRender(text: any, record: any, index: any) {
        return <SIDRender id={text} onClick={() => {
          openInNewTab(`/saleOp/salesWorkBench/salesWorkBenchDetail/${record.id}?authKey=sale`)
        }} />
      },
      checkPhone(text: any, record: any, index: any) {
        return (
            <CheckThePhone
                clueId={record.id}
                initValue={text}
                auth="salePublicInfoViewPhone"
            />
        )
      },
      allReceive(record: any) {
        return iiHOC(
          <Popconfirm title="确认领取吗？" onConfirm={() => allReceiveFn(record)}>
            <Button datareskey="YXBatchHighSeasPoolGet">批量领取</Button>
          </Popconfirm>
        )
      },
      assignDesignAll(record: any) {
        return iiHOC(
          <Button
            onClick={() => {
              assignDesignAll(record)
            }}
            datareskey="YXBatchHighSeasPoolAssign"
          >
            批量指定分配
          </Button>
        )
      },
      operationCell(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn
              title="确认领取吗？"
              confirm
              auth="YXHighSeasPoolGet"
              onClick={() => {
                receive([record.id])
              }}
            >
              领取
            </SActionBtn>
            <SActionBtn
              auth="YXHighSeasPoolAssign"
              onClick={() => {
                clueServiceEdit({ listRef, ids: [record.id], buttonKey: 'YXHighSeasPoolAssign', type: '营销员' })
              }}
            >
              指定分配
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return <SLowcodeList searchMode={'group'} config={{ ...configNew, name: props.listConfigName, [isHeadquarters() ? '' : 'searchInitialValues']: {orgId: companyId} }} ref={listRef} {...extension} />
}

export default function SalePublicInfoPage (props) {
  return <SalePublicInfo {...props}/>
}
